import '../types/externs'
import '../types/externs/users'
import '../types/externs/domains'
import '../types/externs/address'
import '../types/externs/dns'

import Namecheap from './'

module.exports = Namecheap